/**
 * Created by 58 on 2016/9/24.
 */
/*require('./../../style/msg/msg-viewer.less');*/
var Component = require('./../Component');
var $ = require('jQuery');
var template = require('../../template/msg/msg-viewer.html');
var MsgList = require('./MsgList');
var Scrollbar = require('./../Scrollbar');
var Loading = require('./../Loading');

var MsgViewer = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    Component.call(self, defaults);

    // 用来scroll复位，记录当前内容的高度
    self._height_for_mark = null;
    self.scrollMsgId = ''; // 滚动加载历史msg_id，避免多次调用重复接口
    self.scroll_bottom_distance = 0;
    self.min_msg_id = '';
  })(this);

  (function (self) {
    var msglist = new MsgList({
      me: self._options.me,
      onPositionChanged: function (distance) {
        // self._children['scrollbar'].scroll(distance);
      },
      onClick: function (msgItem) {
        self.triggerEvent('onClick', msgItem._data.msg);
      }
    });
    self._children['msglist'] = msglist;
    self._element.append(msglist.getElement());
    msglist.addEventListener('contentMenuOpen', function (options) {
      self.triggerEvent('contentMenuOpen', options);
    });
    msglist.addEventListener('sendMessage', function (options) {
      self.triggerEvent('sendMessage', options);
    });
    msglist.addEventListener('contentMenuClose', function () {
      self.triggerEvent('contentMenuClose');
    });
    msglist.addEventListener('reditContent', function (data) {
      self.triggerEvent('reditContent', data);
    });
    msglist.addEventListener('falseMsgCall', function (call_type) {
      self.triggerEvent('falseMsgCall', call_type);
    });
    msglist.addEventListener('multiple_select_switch', function (data) {
      self._options.multiple_selectable = !!data.active;
    });
    // msglist.addEventListener('contactinfoScroll', function (call_type) {
    //   var height = self._children['msglist'].getElement().outerHeight();
    //   //self._children['msglist'].getElement().css('margin-top', -(height-260));
    //   //self._children['scrollbar'].scrollToBottom()
    // });

  })(this);
};
MsgViewer.prototype = Object.create(Component.prototype);
MsgViewer.prototype.addScrollbar = function () {
  if (this._children['scrollbar'])
    return;
  var self = this;
  var scrollbar = new Scrollbar({
    window: this._element,
    content: this._children['msglist'].getElement()
  });
  this._children['scrollbar'] = scrollbar;
  this._element.append(scrollbar.getElement());
  scrollbar.addEventListener('scrolled', function (scrolltop) {
    // 判断是否滚动到顶部
    if (self._options.contentOpened) self.triggerEvent('contentMenuClose');
    if (scrolltop === 0) {
      var oldmsg = self._children['msglist'].getOldMsg();
      if (!oldmsg || self.scrollMsgId != oldmsg.msg_id) {
        self.scrollMsgId = oldmsg ? oldmsg.msg_id : '';
        self.triggerEvent('oldMsgNeed', oldmsg);
      }
    }
    //判断是否滚动到底部
    var wrapHeight = self.getElement().height();
    var listHeight = self.getElement().find('.im-msg-list').height();
    if (listHeight < wrapHeight) {
      return false
    }
    self.scroll_bottom_distance = listHeight - wrapHeight - scrolltop;
    if (self.scroll_bottom_distance <= 5) {
      //加载更多收藏消息
      self.triggerEvent('addMoreCollectMsg')
    }
  });
  scrollbar.init();
};
/*
 * 添加消息
 * data: 消息（打个对象或者数组
 */
MsgViewer.prototype.addMsg = function (data) {
  this.addScrollbar();
  var self = this;

  var inserted = false;
  if (data instanceof Array) {
    $.each(data, function (index, msg) {
      inserted = self._children['msglist'].add(msg) || inserted;
    });
  }
  else {
    inserted = self._children['msglist'].add(data);
  }

  if (inserted) {
    this._children['msglist'].freshenTime();
    this._children['scrollbar'].calHeight();
  }

  return inserted;
};
// 替换消息
MsgViewer.prototype.replaceMsg = function (data, cb) {
  var self = this;

  var inserted = false;
  if (data instanceof Array) {
    $.each(data, function (index, msg) {
      inserted = self._children['msglist'].replace(msg, cb) || inserted;
    });
  }
  else {
    inserted = self._children['msglist'].replace(data, cb);
  }

  return inserted;
};
// 隐藏消息
MsgViewer.prototype.hideMsg = function (data, cb) {
  var self = this;
  if (data instanceof Array) {
    self._children['msglist'].hideMsg(data, function(count){
      if (count) {
        self._children['scrollbar'].scroll(0);
      }
      cb && cb.apply(self, arguments);
    });
  }
};
// 标机scroll的位置
MsgViewer.prototype.markScroll = function () {
  this._height_for_mark = this._children['msglist'].height();
};
// 回到scroll标记的位置
MsgViewer.prototype.gotoMark = function () {
  var height = this._children['msglist'].height();
  var delta = height - this._height_for_mark;

  console.log('[scrollbar]goto marked position.current height:', height + ', marked height:', this._height_for_mark);

  this._children['scrollbar'].scroll(delta);
};
// 窗口是否填充满
MsgViewer.prototype.checkfull = function () {
  var contentHeight = this._children['msglist'].height();
  var windowHeight = this.height();
  //未填充满
  if (contentHeight < windowHeight) {
    var oldmsg = this._children['msglist'].getOldMsg();
    this.triggerEvent('oldMsgNeed', oldmsg);
  }
};

MsgViewer.prototype.empty = function () {
  this._children['msglist'].empty();
};
MsgViewer.prototype.remove = function (from, to, target_msg_id) {
  this._children['msglist'].remove(from, to, target_msg_id);
};
MsgViewer.prototype.scrollToBottom = function () {
  if (this._children['scrollbar']) {
    this._children['scrollbar'].scrollToBottom();
  }
};
MsgViewer.prototype.getOldMsg = function () {
  return this._children['msglist'].getOldMsg();
};
MsgViewer.prototype.getFreshMsg = function (has_false) {
  return this._children['msglist'].getFreshMsg(has_false);
};
MsgViewer.prototype.updateMsg = function (msg) {
  this._children['msglist'].updateMsg(msg);

  // 发送消息更新，需要滚动到底部
  if (msg.temp_msg_id) {
    this.scrollToBottom();
  }
};
MsgViewer.prototype.updateMsgOtherRead = function () {
  this._children['msglist'].updateMsgOtherRead();
};
MsgViewer.prototype.startLoading = function () {
  if (!this._children['loading']) {
    var loading = new Loading();
    this._children['msglist'].before(loading);
    this._children['loading'] = loading;
  }
  this._children['loading'].open();
};
MsgViewer.prototype.stopLoading = function () {
  if (this._children['loading']) {
    this._children['loading'].close();
  }
};
MsgViewer.prototype.resetScroll = function () {
  if (this._children["scrollbar"]) {
    this._children['scrollbar'].resetWindowHeight();
    this.scrollToBottom();
  }
};

MsgViewer.prototype.multiple_select = function (e) {
  if (this._options.multiple_locked) return;
  this._children['msglist'].multiple_select(e);
};

MsgViewer.prototype.multiple_cancel = function () {
  if (this._options.multiple_locked) return;
  this._children['msglist'].multiple_cancel();
};

MsgViewer.prototype.multiple_check = function () {
  return this._children['msglist'].multiple_check();
};

MsgViewer.prototype.fold = function (distance) {
  //this._children['msglist'].getElement().css('padding-bottom', distance);
};
MsgViewer.prototype.addCollectMsg =function (data) {
  this.addScrollbar();
  var self = this;
  if (data instanceof Array) {
    $.each(data, function (index, msg) {
      self._children['msglist'].addCollectMsg(msg)
    });
  }else {
    self._children['msglist'].addCollectMsg(data);
  }
};


module.exports = MsgViewer;
